<template> 
  <div class="container">
    <div class="page-header">
      <h1 class="page-title full">
        Gérer les types de collectes <br>
        <p class="lead text-muted">Modifiez les types de collectes.</p>
      </h1>
      <div class="page-options d-flex" v-if="isEdit">
        <div class="input-group ml-3 pl-3">
          <button class="btn btn-secondary btn-md" v-on:click.prevent="ajouterType()"> 
            <i class="fe fe-plus"></i> Ajouter un type
          </button>
        </div>
      </div>
    </div>
    <div class="row row-cards">
      <div class="col-12" v-if="loading"><Spinner></Spinner></div>
      <template v-else>
        <div class="col-4">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Types de collectes</h3>
            </div>
            <div class="table-responsive">
              <table class="table card-table table-vcenter text-nowrap">
                <tbody>
                  <tr v-for="type in typesCollectes" class="clickable" :key="type.id"
                      v-on:click.prevent="modifierType(type)">
                    <td>
                      <a href="#"> 
                        {{ type.nom }}
                      </a>            
                    </td>
                    <td class="text-right">
                      <a href="#" class="btn btn-secondary btn-sm">
                        Modifier
                      </a>
                    </td>
                  </tr>
                  <tr v-if="typesCollectes.length == 0" class="text-muted">
                    <td colspan="5"><i>Il n'y a aucun type de collecte.</i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="card" v-if="type">
            <div class="card-header">
              <h3 class="card-title" v-if="isEdit">Modifier un type de collecte</h3>
              <h3 class="card-title" v-else>Ajouter un type de collecte</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="form-label">Nom</label>
                    <input type="text" class="form-control" v-model="type.nom" name="nom"
                      v-validate="'required'" :class="{ 'is-invalid': errors.has('nom') }" data-vv-as="Le nom">
                    <div class="invalid-feedback" v-show="errors.has('nom')">{{ errors.first('nom') }}</div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Description</label>
                    <input type="text" class="form-control" v-model="type.description">
                  </div>
                  <div class="form-group">
                    <label class="form-label">Couleur</label>
                    <div class="input-group">
                      <input type="text" class="form-control" id="color-picker" v-model="type.couleur" name="couleur"
                      v-validate="'required'" :class="{ 'is-invalid': errors.has('couleur') }" data-vv-as="La couleur"
                      v-on:keyup.enter.prevent="setColorPicker()">
                      <span class="colorinput-color picker-color-preview ml-1" v-on:click.prevent="focusCouleur()"
                        v-bind:style="{ 'background-color': type.couleur +' !important' }"></span>
                      <div class="invalid-feedback" v-show="errors.has('couleur')">{{ errors.first('couleur') }}</div>
                    </div>
                  </div>
                  <div class="form-group mb-0">
                    <div class="form-label">
                      Icône de la collecte 
                      <a href="#" v-on:click.prevent="unsetIcone()" class="ml-1 text-red" 
                        v-if="type.icone_path && !iconeDelete">(Supprimer)</a>
                    </div>
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" @change="iconeChange" ref="icone" accept=".png">
                      <label class="custom-file-label">{{ iconeTexte||"Choisir" }}</label>
                    </div>
                    <div class="card card-icon-preview" v-if="type.icone_path && !iconeDelete">
                      <img :src="$storage(type.icone_path)" alt="" style="max-width: 48px;"
                        v-bind:style="{ 'background-color': type.couleur +' !important' }">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-12 p-2">
                  <button type="submit" class="btn btn-primary" :disabled="soumettreDisabled"
                      v-on:click.prevent="sauvegarderType()">
                    Sauvegarder
                  </button>
                  <button type="submit" class="btn btn-secondary" 
                      v-if="isEdit" v-on:click.prevent="annuler()">
                    Annuler
                  </button>

                  <button type="submit" class="btn btn-danger float-right" 
                      v-if="isEdit" v-on:click.prevent="supprimerType()">
                    Supprimer ce type
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { prettyTime } from '../helpers'
  import arraySort from 'array-sort'
  import Spinner from 'vue-simple-spinner'
  import jsonFormData from 'json-form-data'
  import clone from 'clone'

  const TYPE_DEFAULTS = {
    nom: '',
    description: '',
    couleur: '#757575'
  };

  export default {
    components: {
      Spinner,
    },
    data() {
      return {
        loading: true,
        typesCollectes: [],

        type: clone(TYPE_DEFAULTS),
        isEdit: false,
        iconeTexte: null,
        iconeFile: null,
        iconeDelete: false,

        soumettreDisabled: false
      }
    },
    created () {
      this.$store.commit("setTitle", "Types de collectes");
      this.fetchTypes();
      this.ajouterType();
    },
    methods: {
      prettyTime,

      fetchTypes() {
        var self = this;
        Promise.all([ 
          self.$http.get('types_collectes') 
        ]).then(function([ types ]) {
          if (types && types.body && types.body.data) {
            self.typesCollectes = types.body.data;
          }
          self.loading = false;
        })
        .catch(function(err){
          console.log(err);
        });
      },

      initColorPicker() {
        var self = this;
        var $picker = $("#color-picker");
        if ($picker) {
          self.picker = new CP($picker[0]);
          self.picker.on("change", function(color) {
            self.type.couleur = '#' + color;
          });

          var initial = self.type.couleur;
          if (initial.length > 0) {
            this.picker.set(initial);
          }
        }
      },
      setColorPicker() {
        this.picker.set(this.type.couleur);
      },

      focusCouleur() {
        if (this.picker) {
          this.picker.enter();
        }
      },

      ajouterType() {
        this.type = clone(TYPE_DEFAULTS);
        this.isEdit = false;
        this.soumettreDisabled = false;
        this.iconeTexte = null;
        this.iconeFile = null;
        this.iconeDelete = false;
        setTimeout(this.initColorPicker, 200);
        this.$validator.reset();
      },

      modifierType(type) {
        this.type = clone(type);
        this.isEdit = true;
        this.soumettreDisabled = false;
        this.iconeFile = null;
        this.iconeDelete = false;
        var icone_path = this.type.icone_path;
        setTimeout(this.initColorPicker, 200);
      },

      annuler(annuler) {
        this.type = null;
        this.ajouterType();
        window.scrollTo(0, 0);
      },

      iconeChange() {
        var files = this.$refs.icone.files;
        if (files.length > 0) {
          this.iconeFile = files[0];
          this.iconeTexte = files[0].name;
          this.iconeDelete = false;
        }
      },
      unsetIcone() {
        this.iconeTexte = null;
        this.iconeFile = null;
        this.iconeDelete = true;
        $(this.$refs.icone).val('');
      },

      supprimerType() {
        var self = this;
        if (self.isEdit && self.type) {
          if (confirm("Supprimer définitivement ce type de collecte? " +
              "Cette action entrainera la perte de tous les emplacement d'horaire pour ce type.")) {
            self.$http.delete(`types_collectes/${self.type.id}`).then(response => {
              if (response.status == 200) {
                self.$notify.success("Le type a été supprimé.");
                self.fetchTypes();
                self.annuler();
              }
            }, response => {
              // error callback
            });
          }
        }
      },

      sauvegarderType() {
        var self = this;
        self.$validator.validateAll().then((result) => {
          if (result) {
            let type = self.type;
            self.soumettreDisabled = true;

            type.delete_icone = self.iconeDelete;
            if (self.iconeFile) {
              type.icone = self.iconeFile;
            }

            var data = jsonFormData(type);
            if (self.isEdit) {
              self.$http.post(`types_collectes/${type.id}`, data).then(response => {
                if (response.status == 200) {
                  self.$notify.success("Le type a été mis à jour.");
                  self.fetchTypes();
                  self.annuler();
                }
              }, response => {
                // error callback
                this.soumettreDisabled = false;
              });
            } else {
              self.$http.post(`types_collectes`, data).then(response => {
                if (response.status == 200) {
                  self.$notify.success("Le type a été ajouté.");
                  self.fetchTypes();
                  self.annuler();
                }
              }, response => {
                // error callback
                this.soumettreDisabled = false;
              });
            }
          }
        });
      },
    }
  };
</script>



// WEBPACK FOOTER //
// TypesCollectes.vue?86d5a3ec